import React, { useState } from 'react';
import './Shipping.css';

/**
 * Middleman rating, shared by the shipping page and the trade
 * history page - the review stays available wherever the trade is
 * viewed until the trader chooses to submit it (one-shot, no
 * editing, never nagged about).
 */

export function Stars({ onRate, value = 0, disabled = false }) {
    const [hover, setHover] = useState(0);
    return (
        <span className="ship-stars">
            {[1, 2, 3, 4, 5].map(n => (
                <button
                    key={n}
                    disabled={disabled}
                    className={`ship-star${(hover || value) >= n ? ' lit' : ''}`}
                    onMouseEnter={() => !disabled && setHover(n)}
                    onMouseLeave={() => setHover(0)}
                    onClick={() => !disabled && onRate(n)}
                >★</button>
            ))}
        </span>
    );
}

/**
 * One-shot review: pick stars, optionally add a note, then SUBMIT.
 * No editing afterwards.
 */
export function ReviewShop({ shopId, shopName, tradeId, onDone, done }) {
    const [stars, setStars] = useState(0);
    const [note, setNote] = useState('');
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState(null);

    const submit = async () => {
        setBusy(true);
        setErr(null);
        try {
            const res = await fetch(`/api/shops/${shopId}/rate`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ rating: stars, comment: note, tradeId: Number(tradeId) }),
            });
            const json = await res.json();
            if (res.status === 409) { onDone(shopId); return; }
            if (!res.ok) throw new Error(json.error || 'Review failed.');
            onDone(shopId);
        } catch (e) {
            setErr(e.message);
        } finally {
            setBusy(false);
        }
    };

    if (done) {
        return (
            <div className="ship-rate-block">
                <div className="ship-rate-row">
                    <span>{shopName}</span>
                    <span className="ship-hint">✓ Review submitted</span>
                </div>
            </div>
        );
    }

    return (
        <div className="ship-rate-block">
            <div className="ship-rate-row">
                <span>{shopName}</span>
                <Stars value={stars} onRate={setStars} />
            </div>
            <input
                className="ship-rate-comment"
                placeholder="Add a short review note (optional)"
                value={note}
                maxLength={300}
                onChange={e => setNote(e.target.value)}
            />
            <button className="cta-gold ship-rate-submit" disabled={busy || stars < 1} onClick={submit}>
                Submit review
            </button>
            {err && <p className="addr-err">{err}</p>}
        </div>
    );
}

export default ReviewShop;
